@if (sortableGroupsByParent.length > 1) {
    <h3 class="mx-3 mt-3">1. Team objectives supporting organisation objectives</h3>
}
@for (groupData of sortableGroupsByParent; track groupData) {
    <div class="sibling-group"
         [ngClass]="{ 'pt-3 mt-2': sortableGroupsByParent.length > 1 }">
        @if (sortableGroupsByParent.length > 1) {
            <div class="mx-3">
                @if (!!groupData.key) {
                    <div class="d-flex gap-2">
                        <strong>Supporting organisation objective:</strong>
                        <adapt-link-objective [objective]="groupData.key"
                                              [generateHref]="false"
                                              [showStatus]="false"></adapt-link-objective>
                    </div>
                }
                @if (!groupData.key) {
                    @if (groupData.items[0].objective.teamId) {
                        <h3>2. Standalone team objectives</h3>
                    }
                    @if (!groupData.items[0].objective.teamId) {
                        <h3>2. Organisation Objectives</h3>
                    }
                }
            </div>
        }
        <dx-list [activeStateEnabled]="false"
                 [hoverStateEnabled]="false"
                 [focusStateEnabled]="false"
                 [dataSource]="groupData.items"
                 pageLoadMode="scrollBottom"
                 (onItemReordered)="reorderObjectives($event, groupData.items)"
                 [ngClass]="{ indented: indented }">
            <dxo-item-dragging [data]="groupData.items"
                               [allowReordering]="groupData.items.length > 1"></dxo-item-dragging>
            <div *dxTemplate="let objectiveGroup of 'item'">
                <adapt-link-objective [ngClass]="{ 'ms-2': !indented, 'ms-4': indented }"
                                      [objective]="objectiveGroup.objective"
                                      [generateHref]="false"
                                      [showStatus]="false"
                                      [showStatusIcon]="true"></adapt-link-objective>
                @if (sortableChildGroups[objectiveGroup.objective.objectiveId]; as childGroups) {
                    @if (childGroups.length > 1) {
                        <adapt-sortable-objective-groups [objectiveGroups]="childGroups"
                                                         [teamId]="teamId"
                                                         [indented]="true"
                                                         (objectivesReordered)="objectivesReordered.emit($event)"></adapt-sortable-objective-groups>
                    }
                }
            </div>
        </dx-list>
    </div>
}
